module.exports = __webpack_public_path__ + "static/teag_0-ec6c4ef9b52ecca78d09e5ec1280bdfe.jpg";